/* Built In Imports */
/* External Imports */
import { Box, Button, Flex, Image, Link, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SimpleButton from '@moms/Buttons/SimpleButton';
/* Styles */
import DecadeSt from '@moms/styleData/DecadeSt';
import OwnSt from '@moms/styleData/OwnSt';
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const LeftBox = ({ region, lang, sectionContent }) => {
  const title = sectionContent[0]?.titleText;
  const desc = sectionContent[1]?.text;
  const buttonText = sectionContent[2]?.buttonText;
  const buttonLink = sectionContent[2]?.linkUrl;
  const mobileImageData = sectionContent[3]?.mobileImage;
  return (
    <Flex
      flexDir={{ base: 'column' }}
      color={'#FFFFFF'}
      fontFamily="Geist"
      fontWeight={500}
      px="1rem"
      pb="2rem"
      mt={{ base: '0', md: '15%' }}
    >
      <Text {...DecadeSt?.[lang]?.text3}>{title}</Text>
      <Text
        {...DecadeSt?.[lang]?.item3}
        fontSize={{ base: '16px', md: '20px' }}
        lineHeight={'150%'}
        color={'#FFFFFFCC'}
        m="20px 0"
        maxW={'335px'}
      >
        {desc}
      </Text>
      {/* box for button  and icons */}
      <Box
        display={{ base:'none', md:'block' }}
        mt={{ base: '0px', md: '30px' }}
        width={{ base: '100%', sm: '350px', lg: '450px' }}
      >
        <SimpleButton
          mx={{ base: 'auto', sm: '0' }}
          mb="12px"
          height={{ base: '56px', md: '56px' }}
          display={{ base: 'flex' }}
          fontWeight={600}
          borderWidth={'1px'}
          border={'none'}
          borderRadius={'55px'}
          w={{ base: '100%', sm: '350px', lg: '435px' }}
          minW="280px"
          _hover={{ bgColor: '#DBDBDB' }}
          bgColor={'#FFFFFF'}
          mt={{ base: '2.5rem', md: '30px' }}
          style={sectionContent[2]}
          region={region}
          lang={lang}
          py="21px"
          textAlign="center"
          alignItems="center"
          justifyContent="center"
        />
      </Box>
      <Box
        width={'100%'}
        display={{ base: 'block', md: 'none' }}
        right={{ md: '2%', lg: '8%', xl: '12%', '2xl': '20%' }}
      >
        <Image
          width={'100%'}
          objectFit="contain"
          height={'100%'}
          src={mobileImageData?.url}
          alt={mobileImageData?.alt}
        />
      </Box>
    </Flex>
  );
};

const RightBox = ({ region, lang, sectionContent }) => {
  const imageData = sectionContent[3]?.image;
  const mobileImageData = sectionContent[3]?.mobileImage;
  return (
    <Box
      width={{ md: '435px', lg: '720px' }}
      height={{ md: '525px' }}
      display={{ base: 'none', md: 'block' }}
      right={{ md: '2%', lg: '2%', xl: '2%', '2xl': '4%' }}
      alignSelf="flex-end"
      position={'relative'}
    >
      <Image
        src={sectionContent[3].image?.url}
        alt={imageData?.alt || mobileImageData?.alt}
      />
    </Box>
  );
};

const Rewards = ({ region, lang, sectionContent }) => {
  return (
    <Box
      minH={{ md: '540px' }}
      pos={'relative'}
      overflow={'hidden'}
      pt={{ base: '5rem', md: '5rem' }}
    >
      <Flex
        flexDir={{ md: 'row-reverse' }}
        justifyContent={{ md: 'center' }}
        gap={{ md: '1rem', lg: '4rem' }}
        overflowY={'hidden'}
      >
        {/* Right  box  for image */}
        <RightBox region={region} lang={lang} sectionContent={sectionContent} />
        {/* left box */}
        <LeftBox region={region} lang={lang} sectionContent={sectionContent} />
      </Flex>
    </Box>
  );
};

export default Rewards;
